/**
 * 备注计数请求的乱序保护。
 *
 * 列表每次加载会递增一个请求序号；只有当某次计数响应的序号仍等于最新序号时
 * 才采纳，否则返回 null 表示这是过期(被更新一轮请求取代)的响应、应当丢弃，
 * 避免快速翻页/筛选时较早的响应晚到并覆盖当前页计数。
 */
export function pickFreshCommentCount(
  responseSeq: number,
  latestSeq: number,
  response: Record<string, number> | undefined,
): Record<string, number> | null {
  if (responseSeq !== latestSeq) {
    return null;
  }
  return response || {};
}
